export default __webpack_public_path__ + "static/media/smile-face.ee8303a6.svg";